import React from 'react';

import { Profile, Authentication } from './tabs';
import PageTabsAccess from '../../PageTabsAccess';
import { withAppContext } from '../../AppContext';

const TABS = [
    {
        label: 'Profile',
        name: 'profile',
        url: '/account/profile/profile',
        component: Profile,
    },
    {
        label: 'Two-Factor Authentication',
        name: 'authentication',
        url: '/account/profile/authentication',
        component: Authentication,
    },
];

class MyProfile extends React.Component {
    componentDidMount() {
        this.props.updateBreadcrumbs([
            { name: 'Account', path: '/account/profile/profile' },
            'My Profile',
        ]);
    }
    render() {
        const { history, app, tab } = this.props;
        return (
            <div>
                <PageTabsAccess
                    tab={tab}
                    tabs={TABS}
                    onChange={url => history.push(url)}
                    extra={app}
                />
            </div>
        );
    }
}

export default withAppContext(MyProfile);
